/**
 * Formats a number into an abbreviated format with 1 decimal place when appropriate.
 * Examples: 2500 → 2.5k, 1000000 → 1M
 *
 * @param value - The number to format
 * @returns Formatted string with appropriate suffix (k, M, B)
 */
export function formatAbbreviatedNumber(value?: number): string {
  if (value === undefined || value === null) return '-';

  const absValue = Math.abs(value);
  const sign = value < 0 ? '-' : '';

  // Billions
  if (absValue >= 1_000_000_000) {
    return `${sign}${(absValue / 1_000_000_000).toFixed(1).replace(/\.0$/, '')}B`;
  }

  // Millions
  if (absValue >= 1_000_000) {
    return `${sign}${(absValue / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  }

  // Thousands
  if (absValue >= 1_000) {
    return `${sign}${(absValue / 1_000).toFixed(1).replace(/\.0$/, '')}k`;
  }

  // Regular numbers
  // Check if the number is an integer
  if (Number.isInteger(value)) {
    return `${value}`;
  }

  // For non-integer values, show with 1 decimal place
  return value.toFixed(1);
}
